import { useEffect, useState } from "react";
import "./InativarOrigemCarregamentoTrilhosReempregoModal.css";

export default function InativarOrigemCarregamentoTrilhosReempregoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao inativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocrin-bg" onClick={onClose}>
      <div className="ocrin-box" role="dialog" aria-modal="true" aria-label="Inativar origem reemprego" onClick={(e) => e.stopPropagation()}>
        <header className="ocrin-head">
          <h3 className="ocrin-title">Inativar</h3>
          <button className="ocrin-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocrin-body">
          Deseja <strong>inativar</strong> "{titulo || "esta origem"}"?
          {err ? <div className="ocrin-err">{err}</div> : null}
        </div>
        <footer className="ocrin-foot">
          <button className="ocrin-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocrin-btn ocrin-btn-warn" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Inativando..." : "Inativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}


